import { Goal } from '@griply/types';

export type GetLifeAreaTaskListGoalsOptions = {
  isGoalGrouping: boolean;
  showCompletedTasks: boolean;
};

export const getLifeAreaTaskListGoals = (
  sortedLifeAreaGoals: Goal[],
  { isGoalGrouping, showCompletedTasks }: GetLifeAreaTaskListGoalsOptions,
): Goal[] =>
  sortedLifeAreaGoals.filter((goal) => {
    if (isGoalGrouping && goal.archivedAt) {
      return false;
    }

    if (showCompletedTasks) {
      return true;
    }

    const isCompleted = !!goal.completedAt;
    const allTasksCompleted =
      (goal.taskCount ?? 0) === (goal.completedTaskCount ?? 0);

    return !(isCompleted && allTasksCompleted);
  });
